module.exports = __webpack_public_path__ + "img/custom-item3-1.266e2cc.png";